import { Button } from '@mui/material';
import { useNotice } from './NoticeProvider';

/** "Edit Customer" / "Edit Agent": records live in the Serb Mind vault, so editing says it is not available yet */
export function EditRecordButton({ what }: { what: string }) {
  const notice = useNotice();
  return (
    <Button
      variant="outlined"
      onClick={() => notice(`Editing a ${what} is not available yet. It lives in the Serb Mind vault.`, 'info')}
    >
      Edit {what.charAt(0).toUpperCase() + what.slice(1)}
    </Button>
  );
}
